import { pick, prop, propOr } from 'ramda';
import { api, setter, fetchParams, fetchResponse } from '@/modules/helper';

export default {
  namespaced: true,

  state: {
    pagination: {
      skip: 0,
      limit: 10,
    },
    items: [],
  },

  mutations: {
    dynamicSet: setter,
  },

  getters: {
    items: prop('items'),
    pagination: prop('pagination'),
  },

  actions: {
    create(state, payload) {
      return api.post('redeemable', payload.data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },

    update(state, payload) {
      return api.patch(`redeemable/${payload.id}`, payload.data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },

    fetch({ commit, state }, payload) {
      return api
        .get('redeemable', {
          params: fetchParams(state, payload),
        })
        .then(data => commit('dynamicSet', fetchResponse(data)));
    },

    fetchActive({ commit }, userId) {
      return api
        .get(`redeemable/active/${userId}`)
        .then(data => commit('dynamicSet', { items: data.data }));
    },

    find(state, id) {
      return api
        .get(`redeemable/${id}`)
        .then(({ data }) =>
          pick(
            [
              'description',
              'end',
              'id',
              'name',
              'points',
              's3_location',
              'shops',
              'start',
            ],
            data,
          ),
        )
        .catch(error => error);
    },

    remove({ dispatch }, id) {
      return api.delete(`redeemable/${id}`).then(() => dispatch('fetch'));
    },

    reactivate({ dispatch }, id) {
      return api
        .patch(`redeemable/reactivate/${id}`)
        .then(() => dispatch('fetch'));
    },
  },
};
